import { KEY_TEMPLATE, PAD_COMPARE_PARAM_MULTI_WELL, RealtimeTreatmentStorageService } from './../../../shared/services/realtime-treatment-storage.service';
import { IComparePadViewData } from './../../../shared/services/treatment-settings.service';
import { Component, OnInit, ViewChild, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import * as  moment from 'moment';

import { ScatterPlotParameterChartComponent } from '../../../shared/components/charts';

import { IScatterChartInputState, IScatterPlotChartSetting, IAxisSetting, ENUM_AXIS_TYPE, ScatterPlotParameterChartService } from '../../../shared/services/charts/scatter-plot-parameter-chart.service';
import { CompareWellsService } from '../../../shared/services/compare-wells.service';
import { isEmpty, cloneDeep, isEqual, orderBy, each } from 'lodash';
import { ScatterPlotParameterSettingsComponent } from '../../../shared/components/modals/scatter-plot-parameter-settings/scatter-plot-parameter-settings.component';
import { DefaultColor, DefaultShapes, EpochTimeParameters, ENUM_TREATMENT_COLUMNS, DEFUALT_DESIGN_ACUTAL_SHAPES, DEFAULT_DESIGN_COLOR, DEFAULT_ACTUAL_COLOR, isMonitorTreatmentNumber } from '../../../shared/helpers/app.constants';
import { ToasterService, LocalDataStorageService, KEY_DESIGN_ACTUAL_SETTING } from '../../../shared/services';
import { IModelSelectParameters } from '../../../shared/components/select-parameters/select-parameters.component';
import { ITreatmentAvgMDItem, WellsCompareLogDataService } from '../wells-compare-log-data.service';
import { forkJoin, Observable, of, Subject } from 'rxjs';
import { takeUntil, finalize, switchMap } from 'rxjs/operators';
import { WellsCompareDataService, OBJ_FDI_PARAMS } from '../wells-compare-data.service';
import { ITreatmentLogTemplateResponse } from '../../../shared/models/treatment-log-template.model';
import { TreatmentLogTemplateService } from '../../../shared/services/treatment-log-template.service';
import { EXPORT_CHART_TYPE } from '../../../shared/components/export-chart-dropdown/export-chart-dropdown.component';
import { Helper } from '../../../shared/helpers/helper';
import { TreatmentLogParserService } from '../../../shared/services/treatment-log-parser.service';

@Component({
  selector: 'app-compare-parameter-multi-wells',
  templateUrl: './compare-parameter-multi-wells.component.html',
  styleUrls: ['./compare-parameter-multi-wells.component.scss']
})
export class CompareParameterMultiWellsComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject();
  @ViewChild(ScatterPlotParameterChartComponent) scatterHighChart: ScatterPlotParameterChartComponent;

  scatterChartInputState: IScatterChartInputState;
  isDisplayTooltip = true;

  selectedWells = [];
  listParameters = [];
  offsetWells = [];
  fdiOffsetWellsData = [];

  listXAxisOptions = [
    { id: 'well', text: 'Order (Well)' },
    { id: 'time', text: 'Order (Time)' }
  ];
  listYAxisOptions = [];

  listISIPOptions = [];
  listPressureOptions = [];
  listSlurryRateOptions = [];
  listMassOptions = [];
  listVolumeOptions = [];
  listProppantConcOptions = [];
  listFDIOptions = [];
  listTimeOptions = [];

  selectedYAxisOptionParameters: IModelSelectParameters;
  selectedXAxisOption: any[] = [this.listXAxisOptions[1]];
  selectedYAxisOption: any[] = [];
  selectedDesignActualYAxisOption: any[] = [];

  selectedParameters = [];
  inputChartData = [];

  xAxisMode = 'time';

  defaultColors = DefaultColor;
  defaultShapes = DefaultShapes;

  itemsComparing: IAxisSetting[] = [];
  originItemsComparing = [];
  chartSettings: IScatterPlotChartSetting = {
    xAxis: {
      id: this.listXAxisOptions[1].id,
      name: this.listXAxisOptions[1].text
    },
    yAxis: [],
    designActualYAxis: [],
    fdiYAxis: []
  };
  designActualSettings = {
    designShape: DEFUALT_DESIGN_ACUTAL_SHAPES[0].id,
    actualShape: DEFUALT_DESIGN_ACUTAL_SHAPES[0].id,
    designColor: DEFAULT_DESIGN_COLOR,
    actualColor: DEFAULT_ACTUAL_COLOR
  };

  treatmentDetailsStored = {};
  originDesignActualData: any = null;
  designActualData: any = null;
  groupOption: string = 'treatment';
  @Input() loadingTreatmentLogTemplates: boolean;
  dataTreatmentLogTemplates: ITreatmentLogTemplateResponse[] = [];
  @Output() scatterTemplatesChange: EventEmitter<boolean> = new EventEmitter();

  @Input() showWellAliasInTag = true;

  @Input()
  set wellItems(data: any[]) {
    if (data) {
      const wellsList = cloneDeep(data);
      this.itemsComparing = [];
      if (!wellsList.length) {
        this.selectedWells = [];
        this.originItemsComparing = [];
        this.offsetWells = [];
      } else {
        // make the first Well as the Primary Well and others Wells as the Offset Wells
        wellsList[0].isPrimaryWell = true;
        // sort selected wells by first treatment time start
        this.selectedWells = wellsList.length === 1 ? wellsList : orderBy(wellsList, well => {
          return !isEmpty(well.treatmentList) ? well.treatmentList[0].timeStart : 0;
        }, 'asc');
        this.selectedWells.forEach(well => {
          if (well.treatment) {
            // MONITOR doesn't have any meaning on X-AXIS
            // find monitor treatment Ids
            const monitorIds = well.treatmentList.filter(item => item.treatmentNumber === -10).map(item => item.id);
            well.treatment = well.treatment.filter(item => !monitorIds.includes(item.id));
    
            well.firstTreatment = well.treatment[0];
            well.treatment.forEach(treatment => {
              let itemName = `${well.wellName} - Treatment ${treatment.text}`;
              if (well.aliasName && this.showWellAliasInTag) {
                itemName = `(${well.aliasName})-${treatment.text}`;
              }
              const originTreatment = well.treatmentList.find(item => item.id === treatment.id) || {};
              this.itemsComparing.push({
                id: `${well.wellId}_${treatment.id}`,
                name: itemName,
                shape: this.defaultShapes[0],
                color: this.defaultColors[0],
                timeStart: originTreatment.timeStart,
                wellId: well.wellId,
                treatmentId: treatment.id,
                wellName: well.wellName
              });
            });
          }
        });
        this.originItemsComparing = cloneDeep(this.itemsComparing);
        if (this.xAxisMode === 'time') this.itemsComparing = orderBy(this.itemsComparing, item => item.timeStart, 'asc');
        this.offsetWells = this.findOffsetWells(this.selectedWells);
      }

      if (!this.selectedYAxisOptionParameters) {
        this.handleLoadChartBySelectedWellsTreatments(this.selectedWells);
      } else {
        this.onChangeYAxisOption(this.selectedYAxisOptionParameters);
      }
    }
  }

  @Input()
  set parameterItems(data: any[]) {
    if (data) {
      this.listParameters = data;
      this.listYAxisOptions = this.listParameters.map(item => {
        return {
          id: item,
          text: item
        };
      });
      const groupListParameters = this.wellsCompareDataService.toGroupParametersList(this.listYAxisOptions);
      this.listISIPOptions = groupListParameters.listISIPOptions;
      this.listPressureOptions = groupListParameters.listPressureOptions;
      this.listSlurryRateOptions = groupListParameters.listSlurryRateOptions;
      this.listMassOptions = groupListParameters.listMassOptions;
      this.listVolumeOptions = groupListParameters.listVolumeOptions;
      this.listProppantConcOptions = groupListParameters.listProppantConcOptions;
      this.listFDIOptions = groupListParameters.listFDIOptions;
      this.listTimeOptions = groupListParameters.listTimeOptions;
      if (isEmpty(this.selectedYAxisOption) && !isEmpty(this.listPressureOptions)) {
        const listPressureOptionsFormat = this.listPressureOptions.map(item => {
          return {
            id: item.id,
            text: item.text
          };
        });
        const avgPres = listPressureOptionsFormat.find(item => item.id === ENUM_TREATMENT_COLUMNS.AveragePres);

        if (avgPres) {
          this.selectedYAxisOption = [avgPres];
        } else {
          this.selectedYAxisOption = [listPressureOptionsFormat[0]];
        }
        this.chartSettings.yAxis = this.getYAxisSettings(this.selectedYAxisOption);
      }
    }
  }

  // pad mode
  selectedTemplate: any;
  @Input() padName: string;
  comparePadViewData: IComparePadViewData;

  constructor(
    private dialogService: NbDialogService,
    private toasterService: ToasterService,
    private compareWellsService: CompareWellsService,
    private wellsCompareLogDataService: WellsCompareLogDataService,
    private wellsCompareDataService: WellsCompareDataService,
    private localDataStorageService: LocalDataStorageService,
    private treatmentLogTemplateService: TreatmentLogTemplateService,
    private scatterPlotParameterChartService: ScatterPlotParameterChartService,
    private realtimeTreatmentStorageService: RealtimeTreatmentStorageService,
    private treatmentLogParserService: TreatmentLogParserService
  ) { }

  ngOnInit() {
    // get design actual setting
    const localDesignActual = this.localDataStorageService.getOption(KEY_DESIGN_ACTUAL_SETTING);
    if (localDesignActual) {
      this.designActualSettings = localDesignActual;
    }
    // mock
    if (this.padName) {
      this.selectedTemplate = this.realtimeTreatmentStorageService.getOption(this.padName, KEY_TEMPLATE, PAD_COMPARE_PARAM_MULTI_WELL);
      if (this.selectedTemplate) this.onSelectTemplate(this.selectedTemplate);
    }
    this.getTreatmentLogTemplates();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }

  onChangeXAxisOption(item): void {
    if (item) {
      const isDuplicated = this.checkIsDuplicateParameter(this.selectedYAxisOption[0], item);
      if (!isDuplicated) {
        this.selectedXAxisOption = [item];
        this.chartSettings.xAxis = this.getInitialAxisSetting(item.id, item.text);
        this.handleXAxisChange(item.id);
        this.getChartData(this.xAxisMode, this.selectedWells, this.selectedXAxisOption, this.selectedYAxisOption, this.itemsComparing);
        // trigger change detection
        this.chartSettings = Object.assign({}, this.chartSettings);
        if (this.chartSettings) {
          if (this.selectedTemplate && this.selectedTemplate.content) {
            this.setTemplateStorageForPadMode({xAxis: this.chartSettings.xAxis});
          } else {
            this.setTemplateStorageForPadMode(this.chartSettings);
          }
        }
      } else {
        this.toasterService.showError(`${item.text} already exists`);
      }
    }
  }

  onChangeYAxisOption(option: IModelSelectParameters): void {
    this.selectedYAxisOptionParameters = option;

    if (option && option.selected) {
      this.selectedYAxisOption = option.selected;
      const paramFDIs = Object.values(OBJ_FDI_PARAMS);
      const pureYAxis = this.selectedYAxisOption.filter(opt => !paramFDIs.includes(opt.id));
      const fdiYAxis = this.selectedYAxisOption.filter(opt => paramFDIs.includes(opt.id));
      this.chartSettings.yAxis = this.getYAxisSettings(pureYAxis);
      if (option.designActual && !isEmpty(option.designActual.selected)) {
        this.selectedDesignActualYAxisOption = option.designActual.selected;
        const designActualAxis = option.designActual.selected.map(item => {
          return Object.assign(item, { type: ENUM_AXIS_TYPE.DesignActual });
        });
        this.chartSettings.designActualYAxis = this.getYAxisSettings(designActualAxis, this.chartSettings.yAxis.length, true);
        this.chartSettings.fdiYAxis = this.makeFDIYAxisSettings(this.offsetWells, fdiYAxis, this.chartSettings.yAxis.length + 1); // add 1 for design actual
        this.handleLoadChartBySelectedWellsTreatments(this.selectedWells);
      } else {
        // unset design actual parameters
        this.designActualData = null;
        this.chartSettings.fdiYAxis = this.makeFDIYAxisSettings(this.offsetWells, fdiYAxis, this.chartSettings.yAxis.length);
        this.getChartData(this.xAxisMode, this.selectedWells, this.selectedXAxisOption, this.selectedYAxisOption, this.itemsComparing);
      }
      // trigger change detection
      this.chartSettings = Object.assign({}, this.chartSettings);
      if (this.chartSettings) {
        if (this.selectedTemplate && this.selectedTemplate.content) {
          this.setTemplateStorageForPadMode({
            yAxis: this.chartSettings.yAxis,
            designActualYAxis: this.chartSettings.designActualYAxis,
            fdiYAxis: this.chartSettings.fdiYAxis
          });
        } else {
          this.setTemplateStorageForPadMode(this.chartSettings);
        }
      }
    }
  }

  private handleXAxisChange(id): void {
    if (id === 'well') {
      this.xAxisMode = 'well';
      this.itemsComparing = cloneDeep(this.originItemsComparing);
    } else if (id === 'time') {
      this.xAxisMode = 'time';
      this.itemsComparing = orderBy(this.itemsComparing, item => item.timeStart, 'asc');
    } else {
      this.xAxisMode = 'parameter';
    }
  }

  onChangeGroupsOption(opt: string): void {
    if (this.groupOption !== opt) {
      this.groupOption = opt;
      this.setScatterPlotChartInputState(this.xAxisMode, this.itemsComparing, this.chartSettings, this.inputChartData, this.designActualData, this.groupOption);
    }
  }

  private handleLoadChartBySelectedWellsTreatments(selectedWells: any[]): void {
    // only support for multiple wells
    if (!selectedWells || selectedWells.length < 2) return;
    // get treatment detail observable
    let requests$: Observable<ITreatmentAvgMDItem[]>[] = [];
    let selectedTreatments = [];
    const treatmentDetailStorageS = this.wellsCompareDataService.getTreatmentSelectDetails();
    if (!this.treatmentDetailsStored) this.treatmentDetailsStored = {};
    const getTreatmentDataAPIs = (wellId: number, treatments: any[]): Observable<ITreatmentAvgMDItem[]>[] => {
      if (!treatments || !treatments.length) return [];
      const treatmentsInfo: {treatmentId: number, treatmentNumber: number, treatmentName?: string}[] = [];
      for (const treatment of treatments) {
        selectedTreatments.push(treatment);
        if (!!this.treatmentDetailsStored[treatment.id]) continue;
        if (treatmentDetailStorageS[treatment.id]) this.treatmentDetailsStored[treatment.id] = treatmentDetailStorageS[treatment.id];
        else treatmentsInfo.push({treatmentId: treatment.id, treatmentNumber: treatment.treatmentNumber, treatmentName: treatment.treatmentName});
      }
      return [this.wellsCompareLogDataService.getTreatmentsDataForCompareWell(wellId, treatmentsInfo)];
    };
    selectedWells.forEach(well => {
      const treatmentReqs$ = getTreatmentDataAPIs(well.wellId, well.selectedTreatmentList);
      requests$ = requests$.concat(treatmentReqs$);
    });

    if (requests$.length) {
      forkJoin(requests$)
        .pipe(switchMap(items => {
          let treatments: any[] = [];
          items.forEach(item => { treatments = treatments.concat(item); });
          return of(treatments);
        }))
        .pipe(takeUntil(this.destroy$))
        .subscribe(results => {
          results.forEach(treatment => { this.treatmentDetailsStored[treatment.id] = treatment; });

          this.designActualData = this.getLocalDesignActualData(selectedTreatments, this.treatmentDetailsStored);
          this.getChartData(this.xAxisMode, selectedWells, this.selectedXAxisOption, this.selectedYAxisOption, this.itemsComparing);
        });
    } else {
      this.designActualData = this.getLocalDesignActualData(selectedTreatments, this.treatmentDetailsStored);
      this.getChartData(this.xAxisMode, selectedWells, this.selectedXAxisOption, this.selectedYAxisOption, this.itemsComparing);
    }
  }

  private getLocalDesignActualData(selectedTreatments: any[], treatmentDetailsStored): any[] {
    if (!selectedTreatments || !selectedTreatments.length) return [];
    const treatmentDetails: any[] = Object.values(treatmentDetailsStored);
    const designActualData = selectedTreatments.map(treatment => {
      const treatmentData = treatmentDetails.find(tm => tm.id === treatment.id);
      return treatmentData;
    });
    return designActualData;
  }

  getYAxisSettings(axisOption, startIndex = 0, isDesignActual = false) {
    const settings = axisOption.map((setting, yAxisIndex) => {
      const curSetting = this.chartSettings.yAxis.find(item => item.id === setting.id);
      if (curSetting) {
        return curSetting;
      } else {
        return this.getInitialAxisSetting(setting.id, setting.text || setting.name, setting, yAxisIndex + startIndex, isDesignActual);
      }
    });

    return settings;
  }

  getInitialAxisSetting(id, name, obj = {}, yAxisIndex = 0, isDesignActual = false): IAxisSetting {
    const shape = DefaultShapes[yAxisIndex];
    const color = DefaultColor[yAxisIndex];
    const result: IAxisSetting = Object.assign(obj, {
      id: id,
      name: name,
      color: color || '#007ea3',
      shape: shape,
    });
    if (isDesignActual) {
      result.designShape = this.designActualSettings.designShape || DEFUALT_DESIGN_ACUTAL_SHAPES[0].id;
      result.actualShape = this.designActualSettings.actualShape || DEFUALT_DESIGN_ACUTAL_SHAPES[0].id
      result.designColor = this.designActualSettings.designColor || DEFAULT_DESIGN_COLOR;
      result.actualColor = this.designActualSettings.actualColor || DEFAULT_ACTUAL_COLOR;
    }

    return result;
  }

  toggleDisplayTooltip(event) {
    this.isDisplayTooltip = !this.isDisplayTooltip;
    this.scatterHighChart.toggleTooltip(this.isDisplayTooltip);
  }

  zoomOut() {
    this.scatterHighChart.zoomOut();
  }

  reflow() {
    this.scatterHighChart.reflow();
  }

  private setScatterPlotChartInputState(
    xAxisMode: string, itemsComparing: IAxisSetting[], chartSettings: IScatterPlotChartSetting, inputData: any[], designActualData?,
    groupOption?: string
  ): void {
    this.scatterChartInputState = {
      ...this.scatterChartInputState,
      xAxisMode,
      chartSettings,
      itemsComparing: [...itemsComparing],
      inputData: [...inputData],
      designActualData,
      fdiOffsetWellsData: this.fdiOffsetWellsData ? [...this.fdiOffsetWellsData] : [],
      groupOption
    };
  }

  private getChartData(xAxisMode: string, wellList: any[], xAxisOption: any[], yAxisOption: any[], itemsComparing: IAxisSetting[]): void {
    if (!wellList || wellList.length < 2) return; // only support multiple well
    const selectedParameters = this.getSelectedPararmeters(xAxisOption, yAxisOption);
    if (!selectedParameters.length) {
      this.setScatterPlotChartInputState(xAxisMode, itemsComparing, this.chartSettings, this.inputChartData, this.designActualData, this.groupOption);
      return;
    }
    //=== load data via API
    // set treatmentIds
    const treatmentIds = [];
    wellList.forEach(well => {
      if (!isEmpty(well.selectedTreatmentList)) {
        well.selectedTreatmentList.forEach(treatment => {
          if (treatment.id) {
            treatmentIds.push(treatment.id);
          }
        });
      }
    });
    const param: any = {
      wellNames: wellList.map(item => (item.wellName)),
      treatmentIds: treatmentIds,
      listParam: selectedParameters.map(item => (item.id)),
    };
    this.compareWellsService.compareMultiWellChart(param)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res && res.result) {
            this.fdiOffsetWellsData = this.makeFDIOffsetWellsData(this.offsetWells, res.result);

            this.inputChartData = res.result.map(item => {
              item.id = `${item.wellId}_${item.treatmentId}`;
              item.name = `${item.wellName} - Treatment ${item.treatmentNumber}`;
              // datetime parameter
              if (EpochTimeParameters.indexOf(item.paramName) > -1) {
                item.paramUnit = '(datetime)';
              } else { // offset parameter
                // convert unit sec to min
                if (item.paramUnit && item.paramUnit.indexOf('sec') > -1) {
                  item.paramUnit = '(min)';
                  item.paramValue = item.paramValue / 60;
                }
                if (item.paramName === 'TotalPumpTime') {
                  item.paramUnit = '(min)';
                  item.paramValue = item.paramValue / 60;
                }
              }

              return item;
            });
            this.setScatterPlotChartInputState(xAxisMode, itemsComparing, this.chartSettings, this.inputChartData, this.designActualData, this.groupOption);
          }
        }
      );
  }

  private getSelectedPararmeters(xAxisOption: any[], yAxisOption: any[]): any[] {
    if (isEmpty(xAxisOption) || isEmpty(yAxisOption)) return [];
    let result = [];
    const xAxisParameters = xAxisOption.filter(item => item.id && item.id !== 'time' && item.id !== 'well');
    result = xAxisParameters.concat(yAxisOption);
    return result;
  }

  showChartSettings() {
    this.dialogService.open(ScatterPlotParameterSettingsComponent, {
      context: {
        chartSettings: cloneDeep(this.chartSettings)
      }
    })
      .onClose
      .subscribe(
        res => {
          if (res && !isEqual(this.chartSettings, res)) {
            this.chartSettings = res;
            // save design actual setting in local
            if (this.chartSettings.designActualYAxis && !isEmpty(this.chartSettings.designActualYAxis)) {
              this.designActualSettings = {
                designShape: this.chartSettings.designActualYAxis[0].designShape,
                actualShape: this.chartSettings.designActualYAxis[0].actualShape,
                designColor: this.chartSettings.designActualYAxis[0].designColor,
                actualColor: this.chartSettings.designActualYAxis[0].actualColor
              };
              this.localDataStorageService.setOption(KEY_DESIGN_ACTUAL_SETTING, this.designActualSettings);
            }

            if (this.chartSettings) {
              this.setTemplateStorageForPadMode(this.chartSettings);
            }
            this.setScatterPlotChartInputState(this.xAxisMode, this.itemsComparing, this.chartSettings, this.inputChartData, this.designActualData, this.groupOption);
          }
        }
      );
  }

  checkIsDuplicateParameter(curParam, newParam) {
    const result = false;
    if (curParam && newParam) {
      return curParam.id === newParam.id;
    }
    return result;
  }

  getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
  }

  private onExportRawData = () => {
    const textContent = this.scatterPlotParameterChartService.parseMultiDataToStringText(
      this.inputChartData,
      this.selectedXAxisOption,
      this.selectedYAxisOption,
      this.selectedWells
    );
    Helper.saveFileText(textContent, 'Compare_Multi_Wells', 'txt', true);
  }

  onExport(eventData: string) {
    if (eventData === EXPORT_CHART_TYPE.RAW) {
      this.onExportRawData();
    } else {
      let data = '';
      if (this.selectedWells.length > 2) {
        data = moment(new Date()).format('MM-DD-YYYY');
      } else {
        data = this.selectedWells.map(item => item.wellName).join('_');
      }
      this.scatterHighChart.exportChart(`Compare_Parameters_${data}`, eventData);
    }
  }

  handleCuttingStringFDI(str) {
    const strings = str.split('_');
    return strings[strings.length - 1];
  }

  getIdFDI(data) {
    return data.map(item => this.handleCuttingStringFDI(item.id));
  }

  onSelectTemplate(templateRes: ITreatmentLogTemplateResponse) {
    this.selectedTemplate = templateRes;
    if (this.padName) {
      this.realtimeTreatmentStorageService.setOption(this.padName, KEY_TEMPLATE, templateRes, PAD_COMPARE_PARAM_MULTI_WELL);
    }
    if (templateRes && templateRes.content) {
      const template = templateRes.content;
      if (template) {
        // set xAxis
        if (isEmpty(template.xAxis) || !template.xAxis.id || (template.xAxis.id !== 'time' && template.xAxis.id !== 'well')) {
          this.chartSettings.xAxis = this.getInitialAxisSetting(this.listXAxisOptions[0].id, this.listXAxisOptions[0].text);
        } else {
          this.chartSettings.xAxis = template.xAxis;
        }
        // set yAxis
        this.chartSettings.yAxis = template.yAxis;
        this.selectedYAxisOption = template.yAxis.map(item => {
          return Object.assign({ text: item.name }, item);
        });
        this.selectedXAxisOption = [this.chartSettings.xAxis].map(item => {
          return Object.assign({ text: item.name }, item);
        });
        // FDI YAxis
        this.chartSettings.fdiYAxis = template.fdiYAxis;
        if (template.fdiYAxis) {
          const fdiYAxis = cloneDeep(template.fdiYAxis);
          for (const item of fdiYAxis) {
            item.id = this.handleCuttingStringFDI(item.id);
            this.selectedYAxisOption.push(item);
          }
        }
        // design Actual yAxis
        if (template.designActualYAxis) {
          this.chartSettings.designActualYAxis = this.getYAxisSettings(template.designActualYAxis, this.chartSettings.yAxis.length, true);
        } else {
          this.chartSettings.designActualYAxis = [];
        }
        this.selectedDesignActualYAxisOption = this.chartSettings.designActualYAxis.map(item => {
          return Object.assign({ text: item.name }, item);
        });
        this.handleXAxisChange(this.chartSettings.xAxis.id);
        this.getChartData(this.xAxisMode, this.selectedWells, this.selectedXAxisOption, this.selectedYAxisOption, this.itemsComparing);
      }
    }
  }

  onTemplatesChange(eventData): void {
    this.scatterTemplatesChange.emit(true);
  }

  private getTreatmentLogTemplates(): void {
    this.treatmentLogParserService.scatterPlotTemplatesData$.subscribe((data: ITreatmentLogTemplateResponse[]) => {
      this.dataTreatmentLogTemplates = data;
      if (this.padName && !this.selectedTemplate) {
        this.setTemplateStorageForPadMode();
        this.onSelectTemplate(this.selectedTemplate);
      }
    });
  }

  private setTemplateStorageForPadMode(content?: any): void {
    if (this.padName) {
      if (!this.selectedTemplate) {
        this.selectedTemplate = this.dataTreatmentLogTemplates && this.dataTreatmentLogTemplates.length > 0 ? this.dataTreatmentLogTemplates[0] : {
          id: null,
          content: {
            id: null,
            name: null,
            xAxis: null,
            yAxis: [],
            curveYAxis: [],
            designActualYAxis: [],
            scale: [],
            fdiYAxis: [],
          },
          type: null,
          name: null
        };
      } else if (!this.selectedTemplate.content) {
        this.selectedTemplate.content = {
          id: null,
          name: null,
          xAxis: null,
          yAxis: [],
          curveYAxis: [],
          designActualYAxis: [],
          scale: [],
          fdiYAxis: [],
        };
      }
      if (content) {
        each(content, (value, key) => {
          if (this.selectedTemplate.content.hasOwnProperty(key)) {
            this.selectedTemplate.content[key] = value;
          }
        });
      }
      this.realtimeTreatmentStorageService.setOption(this.padName, KEY_TEMPLATE, this.selectedTemplate, PAD_COMPARE_PARAM_MULTI_WELL);
    }
  }

  excludePrimaryWellFDIData(selectedWells, chartData) {
    if (!isEmpty(selectedWells) && !isEmpty(chartData)) {
      const paramFDIs = Object.values(OBJ_FDI_PARAMS);
      const primaryWell = selectedWells.find(item => item.isPrimaryWell);
      const result = [];
      for (let index = 0; index < chartData.length; index++) {
        const item = chartData[index];
        if (item.wellId === primaryWell.wellId && paramFDIs.includes(item.paramName)) {
          continue;
        }
        result.push(item);
      }
      return result;
    }
    return [];
  }

  private findOffsetWells(selectedWells: any[]) {
    if (!selectedWells || !selectedWells.length) return [];
    let result = [];
    for (let index = 0; index < selectedWells.length; index++) {
      const well = selectedWells[index];
      const monitorTreatment = well.treatmentList.find(item => isMonitorTreatmentNumber(item.treatmentNumber));
      if (monitorTreatment) {
        // init monitorIds
        well.fdiTreatmentId = monitorTreatment.id;
        result.push(well);
      }
    }
    return result;
  }

  makeFDIOffsetWellsData(offsetWells, chartData) {
    if (!isEmpty(offsetWells) && !isEmpty(chartData)) {
      const paramFDIs = Object.values(OBJ_FDI_PARAMS);
      const result = [];
      const fdiTreatmentIds = offsetWells.map(offsetWell => offsetWell.fdiTreatmentId);
      for (let index = 0; index < chartData.length; index++) {
        const item = chartData[index];
        if (paramFDIs.includes(item.paramName) && fdiTreatmentIds.includes(item.fdiTreatmentId)) {
          const objData = Object.assign({}, chartData[index]);
          // make id by format wellId_treatmentId, add name
          objData.id = `${objData.wellId}_${objData.treatmentId}`;
          objData.name = `${objData.wellName} - Treatment ${objData.treatmentNumber}`;
          // make paramName by format fdiTreatmentId_paramName
          objData.paramName = `${objData.fdiTreatmentId}_${objData.paramName}`;
          result.push(objData);
        }
      }
      return result;
    }
    return [];
  }

  makeFDIYAxisSettings(offsetWells, pureFDIYAxisSettings, beginYAxisIndex = 0) {
    if (!isEmpty(offsetWells) && !isEmpty(pureFDIYAxisSettings)) {
      let result = [];
      offsetWells.forEach(offsetWell => {
        const setting = pureFDIYAxisSettings.map((setting, yAxisIndex) => {
          const curSetting = this.chartSettings.fdiYAxis.find(item => item.id === `${offsetWell.fdiTreatmentId}_${item.id}`);
          if (curSetting) {
            return curSetting;
          } else {
            const offsetSetting = Object.assign({}, setting);
            const id = `${offsetWell.fdiTreatmentId}_${offsetSetting.id}`;
            const name = `${offsetWell.wellName} - ${offsetSetting.name || offsetSetting.text}`;
            return this.getInitialAxisSetting(id, name, offsetSetting, yAxisIndex + beginYAxisIndex);
          }
        });
        result = result.concat(setting);
      });

      return result;
    }
    return [];
  }

}
